import moduleTemplate from './moduleTemplate'
import serveAPI from '@/api/serve'
const template = moduleTemplate(serveAPI)
template.types = {
  ...template.types,
  setSearchText: 'setSearchText'
}
template.mutations = {
  ...template.mutations,
  [template.types.setSearchText] (state, value) {
    state.searchText = value
  }
}
template.state = {
  ...template.state,
  searchText: ''
}

template.actions = {
  ...template.actions,
  setSearchText ({ dispatch, commit }, searchText) {
    commit(template.types.setSearchText, searchText)
    dispatch('loadServes')
  },
  loadServes ({ state, dispatch, commit }) {
    if (state.isLoading) {
      dispatch('abortLoading')
    }
    template.request = serveAPI.getServes({
      searchText: state.searchText
    })
    commit(template.types.setIsLoading, true)
    return template.request.promise
      .then(params => {
        template.request = null
        commit(template.types.setIsLoading, false)
        commit(template.types.loadItems, params)
        return params.items
      })
  }
}
export default template
